import { type FC } from "react";
import { useFormContext } from "react-hook-form";
import { type FormValues } from "@userFrontend/features/promotion/components/Assessment/schema";
import { Presentation } from "./Presentation";

export const MonthlyCustomerField: FC = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>();
  const value = watch("monthlyCustomers");
  const errorMessage = errors.monthlyCustomers?.message;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue("monthlyCustomers", e.target.value, {
      shouldDirty: true,
    });
  };

  return <Presentation value={value} errorMessage={errorMessage} onChange={handleChange} />;
};
